<template>
  <div class="banner-list">
    <div class="page-header">
      <h2><span class="breadcrumb-level">内容运营</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">内容</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">轮播图管理</span></h2>
      <div class="header-actions">
        <el-input v-model="searchKeyword" placeholder="搜索Banner标题..." clearable prefix-icon="Search" style="width:240px" @input="onSearchInput" />
        <el-button type="primary" @click="handleAdd">添加Banner</el-button>
      </div>
    </div>

    <el-tabs v-model="activeType" @tab-change="fetchData">
      <el-tab-pane label="首页" name="home" />
      <el-tab-pane label="商城首页" name="mall" />
      <el-tab-pane label="活动首页" name="activity" />
      <el-tab-pane label="宠境训练" name="training" />
      <el-tab-pane label="人宠民宿" name="homestay" />
      <el-tab-pane label="工作犬" name="workdog" />
    </el-tabs>

    <el-table :data="banners" stripe v-loading="loading">
      <el-table-column label="排序" width="80">
        <template #default="{ row }">
          <el-input-number v-model="row.sort_order" :min="0" size="small" @change="handleSortChange(row)" />
        </template>
      </el-table-column>
      <el-table-column label="图片" width="120">
        <template #default="{ row }">
          <el-image :src="row.image_url" style="width:80px;height:45px" fit="cover" />
        </template>
      </el-table-column>
      <el-table-column label="标题" prop="title" min-width="150" />
      <el-table-column label="类型" width="100">
        <template #default="{ row }">
          <el-tag size="small">{{ typeLabel(row.type) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="跳转" width="100">
        <template #default="{ row }">
          <el-tag>{{ row.link_type || '无' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template #default="{ row }">
          <el-switch v-model="row.status" @change="handleStatusChange(row)" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="{ row }">
          <el-button size="small" @click="handleEdit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination.total > 0"
      v-model:current-page="pagination.current_page"
      v-model:page-size="pagination.per_page"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20,50]"
      small
      background
      style="margin-top:16px;justify-content:flex-end"
      @current-change="fetchData"
      @size-change="fetchData"
    />

    <el-dialog v-model="dialogVisible" :title="isEdit ? '编辑轮播图' : '添加轮播图'" width="600px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type">
            <el-option label="首页" value="home" />
            <el-option label="商城首页" value="mall" />
            <el-option label="活动首页" value="activity" />
            <el-option label="宠境训练" value="training" />
            <el-option label="人宠民宿" value="homestay" />
            <el-option label="工作犬" value="workdog" />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="图片" prop="image_url">
          <Upload v-model="form.image_url" :max-count="1" :tip="BANNER_TIPS[form.type] || ''" />
        </el-form-item>
        <el-form-item label="跳转类型">
          <el-select v-model="form.link_type" placeholder="无跳转" clearable>
            <el-option label="无跳转" value="none" />
            <el-option label="URL链接" value="url" />
            <el-option label="活动" value="activity" />
            <el-option label="页面" value="page" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.link_type === 'url'" label="跳转值">
          <el-input v-model="form.link_value" placeholder="请输入URL链接" />
          <div style="font-size:12px;color:#909399;margin-top:4px;line-height:1.4;">
            ⚠️ 链接域名需在微信小程序后台配置为业务域名，否则无法正常打开
          </div>
        </el-form-item>
        <el-form-item v-if="form.link_type === 'activity'" label="选择活动">
          <el-select v-model="form.link_value" placeholder="请选择活动" filterable style="width:100%">
            <el-option v-for="a in activityList" :key="a.id" :label="a.title" :value="String(a.id)" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.link_type === 'page'" label="选择页面">
          <el-select v-model="form.link_value" placeholder="请选择自定义页面" filterable style="width:100%">
            <el-option v-for="p in customPageList" :key="p.id" :label="p.title" :value="String(p.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort_order" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import * as contentApi from '../../api/contentManagement';
import * as activityApi from '../../api/activity';
import Upload from '../../components/Upload.vue';

const banners = ref([]);
const loading = ref(false);
const pagination = reactive({ current_page: 1, per_page: 20, total: 0, last_page: 1 });
const dialogVisible = ref(false);
const isEdit = ref(false);
const formRef = ref(null);
const activeType = ref('home');
const searchKeyword = ref('');
let searchTimer = null;
const onSearchInput = () => { clearTimeout(searchTimer); searchTimer = setTimeout(fetchData, 300); };
const activityList = ref([]);
const customPageList = ref([]);
const form = ref({
  title: '', image_url: '', link_type: 'none', link_value: '',
  sort_order: 0, status: true, type: 'home',
});
const rules = {
  title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
  image_url: [{ required: true, message: '请上传图片', trigger: 'change' }],
  type: [{ required: true, message: '请选择类型', trigger: 'change' }],
};

const typeLabel = (t) => ({ home: '首页', mall: '商城首页', activity: '活动首页', training: '宠境训练', homestay: '人宠民宿', workdog: '工作犬' }[t] || t);

// 各位置的推荐图片尺寸（按小程序端实际渲染尺寸推导）
const BANNER_TIPS = {
  home: '推荐尺寸 宽 750 × 高 800 px',
  mall: '推荐尺寸 宽 512 × 高 150 px',
  activity: '推荐尺寸 宽 690 × 高 320 px',
  training: '推荐尺寸 宽 690 × 高 320 px',
  homestay: '推荐尺寸 宽 750 × 高 400 px',
  workdog: '推荐尺寸 宽 690 × 高 320 px',
};

const fetchActivities = async () => {
  try { const r = await activityApi.getActivities(); activityList.value = r.data || []; }
  catch {}
};
const fetchCustomPages = async () => {
  try { const r = await contentApi.getCustomPages(); customPageList.value = r.data || []; }
  catch {}
};
const fetchData = async () => {
  loading.value = true;
  try {
    const params = { page: pagination.current_page, per_page: pagination.per_page, type: activeType.value };
    if (searchKeyword.value) params.search = searchKeyword.value;
    const res = await contentApi.getBanners(params);
    banners.value = res.data || [];
    pagination.current_page = res.pagination?.current_page || 1;
    pagination.total = res.pagination?.total || 0;
  } catch { ElMessage.error('获取Banner列表失败'); } finally { loading.value = false; }
};

const handleAdd = () => {
  isEdit.value = false;
  form.value = { title: '', image_url: '', link_type: 'none', link_value: '', sort_order: 0, status: true, type: activeType.value };
  dialogVisible.value = true;
};

const handleEdit = (row) => {
  isEdit.value = true;
  form.value = { ...row };
  dialogVisible.value = true;
};

const handleSave = async () => {
  const valid = await formRef.value.validate().catch(() => false);
  if (!valid) return;
  try {
    if (isEdit.value) { await contentApi.updateBanner(form.value.id, form.value); ElMessage.success('更新成功'); }
    else { await contentApi.createBanner(form.value); ElMessage.success('创建成功'); }
    dialogVisible.value = false;
    await fetchData();
  } catch { ElMessage.error('操作失败'); }
};

const handleDelete = (row) => {
  ElMessageBox.confirm('确定删除该Banner？', '提示').then(async () => {
    await contentApi.deleteBanner(row.id);
    ElMessage.success('删除成功');
    await fetchData();
  }).catch(() => {});
};

const handleSortChange = async (row) => { await contentApi.updateBanner(row.id, { sort_order: row.sort_order }); };
const handleStatusChange = async (row) => { await contentApi.updateBanner(row.id, { status: row.status }); };
onMounted(() => { fetchData(); fetchActivities(); fetchCustomPages(); });
</script>

<style scoped>
.header-actions { display: flex; gap: 12px; align-items: center; }
.upload-img { width: 200px; height: 120px; object-fit: cover; border-radius: 4px; }
.upload-icon { font-size: 28px; color: #8c939d; }
.avatar-uploader { border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; padding: 20px; text-align: center; }
.avatar-uploader:hover { border-color: #409eff; }
</style>
